module.exports = __webpack_public_path__ + "static/media/goods.dbb24e48.jpg";